import { Dialog, DialogContent, Button, Input, LucideIcon } from '@skin-seoul/design-system';
import { useState } from 'react';

interface TrackOrderModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const TrackOrderModal = ({ isOpen, onClose }: TrackOrderModalProps) => {
  const [orderNumber, setOrderNumber] = useState('');
  const [email, setEmail] = useState('');

  const handleTrackOrder = (e: React.FormEvent) => {
    e.preventDefault();
    const params = new URLSearchParams({
      email: email.trim(),
      orderNumber: orderNumber.trim(),
    });
    window.location.href = `/delivery-tracking/?${params.toString()}`;
  };

  const isFormValid = orderNumber.trim() !== '' && email.trim() !== '';

  return (
    <Dialog open={isOpen}>
      <DialogContent
        showCloseButton={false}
        className="max-w-full tablet:max-w-[800px] desktop:max-w-[900px] w-full rounded-t-xl tablet:rounded-xl rounded-b-none tablet:rounded-b-xl p-6 overflow-hidden bg-generic-0"
      >
        <div className="flex justify-between items-end mb-8 w-full">
          <p className="text-heading-h6 font-semibold text-neutral-800" style={{ letterSpacing: '-0.4px' }}>
            Track an Order
          </p>
          <Button className="hover:opacity-70 pr-0" variant="ghost" size="sm" onClick={onClose} type="button">
            <LucideIcon name="X" size={16} />
          </Button>
        </div>

        <form className="flex flex-col tablet:flex-row gap-5 w-full" onSubmit={handleTrackOrder}>
          <div className="flex flex-col flex-1 items-stretch gap-6 min-w-0">
            <div className="flex flex-col items-stretch gap-2">
              <p className="text-heading-h6-mobile font-medium text-neutral-900">Track your guest order</p>
              <p className="text-paragraph-small font-normal text-neutral-400">
                Check your delivery status by entering your email and order number below.
              </p>
            </div>

            <div className="flex flex-col items-stretch gap-3">
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email Address"
                required
              />
              <Input
                value={orderNumber}
                onChange={(e) => setOrderNumber(e.target.value)}
                placeholder="Order Number"
                required
              />
              <Button
                variant="primary"
                className="w-full h-[50px] rounded-[8px] font-medium text-label-large hover:bg-primary-500"
                type="submit"
                disabled={!isFormValid}
              >
                Check Order Status
              </Button>
            </div>
          </div>

          <div className="hidden tablet:flex w-px bg-neutral-75 self-stretch shrink-0" />
          <div className="flex tablet:hidden h-px bg-neutral-75 w-full shrink-0" />

          <div className="flex flex-col flex-1 items-stretch gap-6 justify-start min-w-0">
            <div className="flex flex-col items-stretch gap-2">
              <p className="text-heading-h6-mobile font-medium text-neutral-900">Sign in to see all your orders</p>
              <p className="text-paragraph-small font-normal text-neutral-400">
                View your purchase history, track deliveries, and enjoy your SkinSociety rewards — all in one place.
              </p>
            </div>

            <Button
              variant="primary"
              onClick={() => {
                window.location.href = '/login/';
              }}
            >
              Sign In
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
